module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/handcash-logo-round-7c6793b653682ee1.png"+" 200w",
        images: [{path: __webpack_public_path__ + "assets/images/handcash-logo-round-7c6793b653682ee1.png",width: 200,height: 200}],
        src: __webpack_public_path__ + "assets/images/handcash-logo-round-7c6793b653682ee1.png",
        toString: function(){return __webpack_public_path__ + "assets/images/handcash-logo-round-7c6793b653682ee1.png"},
        
        width: 200,
        height: 200
      }